import { Component, input, output } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { FileResponse } from '../../../../core/clients/omni-core/models';
import { SimpleDialogLayout, Button } from 'excellence-ui';
import { NgIcon } from '@ng-icons/core';
import { DocumentFilenamePipe } from '../../pipes/document-filename-pipe';
import { DocumentDownloadButton } from '../../components/document-download-button/document-download-button';
import { DocumentPreview } from '../../components/document-preview/document-preview';

@Component({
  selector: 'app-document-preview-dialog',
  imports: [
    SimpleDialogLayout,
    Button,
    NgIcon,
    DocumentFilenamePipe,
    TranslocoPipe,
    DocumentDownloadButton,
    DocumentPreview,
  ],
  templateUrl: './document-preview-dialog.html',
})
export class DocumentPreviewDialog {
  document = input.required<FileResponse>();
  organizationID = input.required<string>();

  clickCancel = output();
}
